export async function fetchStaticJson(url) {
    let res;
    try {
        const link = `${url}?ver=${Date.now()}`;
        res = await fetch(link);

        if (res && res.ok) {
            const resJson = await res.json();
            return resJson;
        } else {
            throw new Error(`failed to fetch json url: ${url} with status: ${res && res.status}`);
        }
    } catch (err) {
        throw new Error(`error fetching ${url}: ${err.message}`);
    }
}

export function resolveAssetUrl(assetPath) {
    if (!assetPath) return '';
    if (/^https?:\/\//i.test(assetPath)) return assetPath;
    const baseUrl = window.config.assetsBaseUrl ?? '';
    return `${baseUrl}${assetPath}`;
}
